import { BaseModel } from 'core/models/base.model.js';


export var HistoSouhaitOriginModel = BaseModel.extend({

  url: function() {
    var newUrl = Configuration.restRoot + "/rest/wkf/histo/souhait/" + encodeURIComponent(this.ctxRefSouhait);
    return newUrl;
  }
});